import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';
import { NaReuseTabService } from './na-reuse-tab.service';

/**
 * è·¯ç±å¤ç¨ç­ç¥
 */
export class NaReuseTabStrategy implements RouteReuseStrategy {
  constructor(private srv: NaReuseTabService) {}

  /**
   * æ¯å¦ç¼å­[ç¦»å¼è·¯ç±æ¶è§¦å]
   * @param route è·¯ç±å¿«ç§
   */
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return this.srv.shouldDetach(route);
  }
  /**
   * ç¼å­ç»ä»¶[ç¦»å¼è·¯ç±æ¶è§¦å]
   * @param route   è·¯ç±å¿«ç§
   * @param handle  ç»ä»¶å½åå®ä¾å¯¹è±¡
   */
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    this.srv.store(route, handle);
  }
  /**
   * æ¯å¦è¿å[è¿å¥è·¯ç±æ¶è§¦å]
   * @param route è·¯ç±å¿«ç§
   */
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return this.srv.shouldAttach(route);
  }
  /**
   * è¿åè·¯ç±[è¿å¥è·¯ç±æ¶è§¦å]
   * @param route è·¯ç±å¿«ç§
   */
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return this.srv.retrieve(route);
  }
  /**
   * æ¯å¦å¤ç¨è·¯ç±[è¿å¥è·¯ç±æ¶è§¦å]
   * @param future  å°è¦è¿å¥å°è·¯ç±å¿«ç§
   * @param curr    å½åè·¯ç±å¿«ç§
   */
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return this.srv.shouldReuseRoute(future, curr);
  }

}
